var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoverbox",on:{"mouseover":function($event){return _vm.mouseover($event)},"mouseout":function($event){return _vm.mouseout($event)},"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }